export type Language = 'en' | 'ru' | 'uz';

export type TranslationsMap<T> = {
  en: T;
  ru: T;
  uz: T;
};

export function createTranslations<T extends Record<string, string>>(
  translations: TranslationsMap<T>
): TranslationsMap<T> {
  return translations;
}
